import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"

import {
  AddonAccordion,
  AddonAccordionProps
} from "widgets/product-configurator/ui/addons/AddonAccordion"
import { AddonDisplayProps } from "widgets/product-configurator/ui/addons/AddonDisplay.types"

export interface ProductConfiguratorAddonsViewModel
  extends AddonAccordionProps,
    AddonDisplayProps {}

export const ProductConfiguratorAddonsView = React.memo(
  (props: ProductConfiguratorAddonsViewModel) => (
    <ScrollArea.Root className="scroll-area scroll-area--vertical shadow-s addon-configuration-step">
      <ScrollArea.Viewport className="scroll-area__viewport">
        <ScrollArea.Content className="scroll-area__content addon-configuration-step__content">
          <AddonAccordion
            className="addon-configuration-step__accordion"
            {...props}
          />
        </ScrollArea.Content>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar
        orientation="vertical"
        className="scroll-area__scrollbar"
      >
        <ScrollArea.Thumb className="scroll-area__thumb" />
      </ScrollArea.Scrollbar>
    </ScrollArea.Root>
  )
)
